var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalBriefcaseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 99.87",
    style: {
      enableBackground: "new 0 0 122.88 99.87"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.73,18.67h31.73V4.04c0-2.22,1.82-4.04,4.05-4.04h42.62c2.22,0,4.04,1.82,4.04,4.04v14.62h32.98 c2.05,0,3.73,1.68,3.73,3.73v73.74c0,2.05-1.68,3.73-3.73,3.73l-115.42,0C1.68,99.87,0,98.19,0,96.14V22.4 C0,20.34,1.68,18.66,3.73,18.67L3.73,18.67L3.73,18.67z M43.55,18.67h34.53v-7.16c0-2.22-1.82-4.04-4.04-4.04H47.6 c-2.22,0-4.04,1.82-4.04,4.04V18.67L43.55,18.67z M69.25,35.26v16.19h16.19v15.63l-16.19,0v16.19H53.62V67.08H37.43V51.45l16.19,0 V35.26H69.25L69.25,35.26z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalBriefcaseIcon);
export default __webpack_public_path__ + "static/media/medical-briefcase-icon.3f0182713c745f62b0d90159278f11f5.svg";
export { ForwardRef as ReactComponent };